import { gql, TypedDocumentNode } from "@apollo/client";

import { OriginIntegration } from "types/generated";

type GetOriginBuiltInIntegrationData = {
  originIntegration: OriginIntegration | null;
};

export const GET_ORIGIN_BUILT_IN_INTEGRATION: TypedDocumentNode<GetOriginBuiltInIntegrationData> = gql`
  query GetOriginBuiltInIntegration {
    originIntegration {
      vcsChecks
      useGitCheckout
      installationTarget
      repoSelectionMode
      scopes
    }
  }
`;

type DeleteOriginIntegrationData = {
  originIntegrationDelete: boolean;
};

export const DELETE_ORIGIN_INTEGRATION: TypedDocumentNode<DeleteOriginIntegrationData> = gql`
  mutation DeleteOriginIntegration {
    originIntegrationDelete
  }
`;
